var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _class2, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import objectTrait from "../Decorators/objectTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import ModelTraits from "../ModelTraits";
import OpacityTraits from "./OpacityTraits";
import SplitterTraits from "./SplitterTraits";
import FeaturePickingTraits from "./FeaturePickingTraits";
export let TileErrorHandlingTraits = (_dec = primitiveTrait({
  type: "number",
  name: "tileErrorThresholdBeforeDisabling",
  description: "The number of tile failures before disabling the item."
}), _dec2 = primitiveTrait({
  type: "boolean",
  name: "treat403AsError",
  description: "Indicates whether a 403 response code when requesting a tile should be treated as an error. If false, 403s are assumed to just be missing tiles and need not be reported to the user."
}), _dec3 = primitiveTrait({
  type: "boolean",
  name: "treat404AsError",
  description: "Indicates whether a 404 response code when requesting a tile should be treated as an error. If false, 404s are assumed to just be missing tiles and need not be reported to the user."
}), _dec4 = primitiveTrait({
  type: "boolean",
  name: "ignoreUnknownTileErrors",
  description: "A flag indicating whether non-specific (no HTTP status code) tile errors should be ignored. This is a last resort, for dealing with odd cases such as data sources that return non-images (eg XML) with a 200 status code. No error messages will be shown to the user."
}), _class = class TileErrorHandlingTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "thresholdBeforeDisablingItem", _descriptor, this);
    _initializerDefineProperty(this, "treat403AsError", _descriptor2, this);
    _initializerDefineProperty(this, "treat404AsError", _descriptor3, this);
    _initializerDefineProperty(this, "ignoreUnknownTileErrors", _descriptor4, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "thresholdBeforeDisablingItem", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "treat403AsError", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "treat404AsError", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "ignoreUnknownTileErrors", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
let ImageryProviderTraits = (_dec5 = primitiveTrait({
  type: "number",
  name: "Leaflet update interval",
  description: "Update a tile only once during this interval when the map is panned. Value should be specified in milliseconds."
}), _dec6 = objectTrait({
  type: TileErrorHandlingTraits,
  name: "tileErrorHandling",
  description: "Options for handling tile errors"
}), _dec7 = primitiveTrait({
  type: "boolean",
  name: "Clip to rectangle",
  description: "Gets or sets a value indicating whether this dataset should be clipped to the {@link CatalogItem#rectangle}.\nIf true, no part of the dataset will be displayed outside the rectangle.\nThis property is true by default, leading to better performance and avoiding tile request errors that might occur when requesting tiles outside the server-specified rectangle.\nHowever, it may also cause features to be cut off in some cases, such as if a server reports an extent that does not take into account that the representation of features sometimes require a larger spatial extent than the features themselves.\nFor example, if a point feature on the edge of the extent is drawn as a circle with a radius of 5 pixels, half of that circle will be cut off."
}), _dec8 = primitiveTrait({
  name: "Minimum Level",
  description: "The minimum level-of-detail supported by the imagery provider. Take care when specifying this that the number of tiles at the minimum level is small, such as four or less. A larger number is likely to result in rendering problems",
  type: "number"
}), _dec9 = primitiveTrait({
  name: "Maximum Level",
  description: "The maximum level-of-detail supported by the imagery provider, or undefined if there is no limit",
  type: "number"
}), _dec0 = primitiveTrait({
  type: "number",
  name: "Tile width (in pixels)",
  description: "Tile width in pixels. Default value is 256 pixels"
}), _dec1 = primitiveTrait({
  type: "number",
  name: "Tile height (in pixels)",
  description: "Tile height in pixels. Default value is 256 pixels"
}), _class2 = class ImageryProviderTraits extends mixTraits(FeaturePickingTraits, OpacityTraits, SplitterTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "leafletUpdateInterval", _descriptor5, this);
    _initializerDefineProperty(this, "tileErrorHandlingOptions", _descriptor6, this);
    _initializerDefineProperty(this, "clipToRectangle", _descriptor7, this);
    _initializerDefineProperty(this, "minimumLevel", _descriptor8, this);
    _initializerDefineProperty(this, "maximumLevel", _descriptor9, this);
    _initializerDefineProperty(this, "tileWidth", _descriptor0, this);
    _initializerDefineProperty(this, "tileHeight", _descriptor1, this);
  }
}, _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "leafletUpdateInterval", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "tileErrorHandlingOptions", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      thresholdBeforeDisablingItem: 5,
      treat403AsError: true,
      treat404AsError: false,
      ignoreUnknownTileErrors: false
    };
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "clipToRectangle", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "minimumLevel", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "maximumLevel", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class2.prototype, "tileWidth", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 256;
  }
}), _descriptor1 = _applyDecoratedDescriptor(_class2.prototype, "tileHeight", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 256;
  }
}), _class2);
export { ImageryProviderTraits as default };